/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { Component } from "react";
import { Scrollbars } from "react-custom-scrollbars";
import ReactTooltip from "react-tooltip";
import { Views } from "react-big-calendar";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import DatePicker from "react-datepicker";
import { Link } from "react-router-dom";
import { DragDropContext } from "react-dnd";
import HTML5Backend from "react-dnd-html5-backend";
import moment from "moment";
import AppointmentHeader from "../AppointmentHeader.js";
import {
  checkRescheduleTime,
  getProviderAppointments,
  printAppointment,
  rescheduleAppointment,
  sendNotification,
} from "../../../Actions/Appointment/appointmentAction.js";
import calenLogo from "../../../_legacy/images/calender.svg";
import {
  capitalizeFirstLetter,
  checkIfPermissionAllowed,
  displayName,
} from "../../../Utils";
import { cond, pipe } from "../../../utilities/fp.js";
import {
  CALENDAR_STEP_OPTIONS,
  CalendarStepSelect,
} from "./components/CalendarStepSelect/CalendarStepSelect.js";
import classes from "./styles/Calendar.module.scss";
import { apiDateFormat, showSelectedWeek, viewDateFormat } from "./utilities";
import { uiNotification } from "../../../services/UINotificationService.js";
import { history } from "../../../history.js";
import { dateToApiDateString } from "../../../utilities/api.js";
import { API_DATE_FORMAT } from "../../../consts/api.js";
import { withGetBookingUrlsQuery } from "../../../api/queries/useGetBookingUrlsQuery.js";
import { EVENT_TYPES } from "../../../store/event/consts";
import { isEmpty } from "../../../utilities/general";
import {
  buildChargeAndRescheduleData,
  buildMoveEventState,
  buildRescheduleAppointmentData,
  buildRescheduleNotificationData,
  formatCalendarTimeRange,
  getCalendarDateRange,
  getCalendarFetchRange,
  getCalendarNavigationState,
  getCalendarViewDateState,
  getClinicNow,
  getDroppedEventAllDayValue,
  getMoveEventValidation,
  getOutOfOfficeRescheduleTime,
  getRescheduleRedirectUrl,
  getRescheduleSuccessState,
  mapAppointmentToCalendarEvent,
  mapAvailabilityScheduleToEvent,
  notifyRescheduleError,
} from "./calendarShared";
import { CalendarDragAndDrop } from "./components/CalendarDragAndDrop";
import { CalendarModals } from "./components/CalendarModals";
import { CalendarClinicDropdown } from "./components/CalendarClinicDropdown";
import { VerticalsLegend } from "./components/VerticalsLegend";

class ProviderWeekCalendar extends Component {
  constructor(props) {
    super(props);

    const languageData = JSON.parse(localStorage.getItem("languageData")) || {
      global: {},
      appointments: {},
    };

    const timeFormat = localStorage.getItem("timeFormat");
    let user = JSON.parse(localStorage.getItem("userData"));

    let calendarFilter = JSON.parse(localStorage.getItem("providerWeekFilter"));

    this.state = {
      timeFormat,
      showSelectedDate: calendarFilter
        ? calendarFilter.calendarView === Views.WEEK
          ? showSelectedWeek(calendarFilter.searchPickerDate)
          : viewDateFormat(calendarFilter.searchPickerDate)
        : moment().format("LL"),
      selectedDate: calendarFilter
        ? moment(calendarFilter.searchPickerDate).toDate()
        : moment().toDate(),
      providers: [],
      tmpProviders: [],
      clinics: [],
      calendarView: Views.DAY,
      showLoader: false,
      showProvider: false,
      showService: false,
      showClinics: false,
      selectedProviders: [],
      selectedServices: [],
      selectedClinic: "",
      showAppointmentDetails: false,
      editAppointmentId: 0,
      notificationSent: false,
      globalLang: languageData.global,
      appointmentLang: languageData.appointments,
      forceChanged: false,
      showNotifyPop: false,
      showModal: false,
      showPrintModal: false,
      notification_type: "emailAndSms",
      selectAllProviders: false,
      showRescheduleConfirmModal: false,
      userData: user,
      success_msg: "",
      patient_name: "",
      printTimeStamp: new Date(),
      clinic_timezone: "",
      verticalsList: [],
      selectedVertical: {
        id: 0,
        name: "Default View",
      },
      searchProvider: "",
      verticalsEnabled: user.user.vertical_view,
      needAppointmentsUpdate: true,
      calendarStep: CALENDAR_STEP_OPTIONS[0],
    };

    window.onscroll = () => {
      return false;
    };

    this.moveEvent = this.moveEvent.bind(this);
  }

  handleSelect = (event) => {
    const { start, resourceId } = event;

    const eventDate = dateToApiDateString(start);

    const provider = this.state.resourceMap?.find(
      (x) => String(x.resourceId) === String(resourceId),
    );

    const workingHours = provider?.workingHours?.find(
      (x) => x.date === eventDate,
    );

    const schedule = workingHours?.schedule?.find((x) =>
      moment(moment(start).format(`${API_DATE_FORMAT} HH:mm:ss`)).isBetween(
        x.start,
        x.end,
        undefined,
        "[)",
      ),
    );

    const time = moment(start);

    if (schedule && time.isAfter(this.getNow())) {
      history.push(
        `/appointment/create/${resourceId}/${
          this.state.clinic_id
        }/${apiDateFormat(start)}/${time.format("HH:mm:ss")}`,
      );
    }
  };

  getNow = () => {
    return getClinicNow(this.state.clinic_timezone);
  };

  timeRangeFormat = ({ start, end }, culture, localizer) => {
    return formatCalendarTimeRange(
      { start, end },
      culture,
      localizer,
      this.state.timeFormat,
    );
  };

  moveEvent({ event, start, end, resourceId, isAllDay: droppedOnAllDaySlot }) {
    const validation = getMoveEventValidation({
      event,
      start,
      resourceId,
      events: this.state.events,
      checkSameStart: true,
      ignoreAvailabilityOverlap: true,
      checkOutsideAvailability: true,
    });

    if (validation.error) {
      uiNotification.error(validation.error);
    }

    if (!validation.isValid) {
      return validation.shouldReturnFalse ? false : undefined;
    }

    const allDay = getDroppedEventAllDayValue({
      event,
      droppedOnAllDaySlot,
    });

    this.setState(
      buildMoveEventState({ event, start, end, resourceId, allDay }),
    );
  }

  handleReschedule = (formData) => {
    this.setState({
      showLoader: true,
    });

    this.props
      .rescheduleAppointment(formData)
      .then((data) => {
        let returnState = getRescheduleSuccessState(data, {
          includeNotiType: true,
        });

        if (!returnState.showNotifyPop) {
          this.refreshAppointments();
          uiNotification.success("Appointment rescheduled successfully");
        }

        this.setState(returnState);
      })
      .catch((res) => {
        notifyRescheduleError(res);
      })
      .finally(() => {
        this.setState({
          showLoader: false,
        });
      });
  };

  rescheduleAppoint = () => {
    localStorage.setItem("showLoader", true);

    this.setState({
      showLoader: true,
      showRescheduleConfirmModal: false,
    });

    let formData = this.state.rescheduleFormData;

    this.props.checkRescheduleTime(formData).then((data) => {
      const rescheduleData = data.data || {};
      let returnState = {};

      if (rescheduleData.status === "fail") {
        returnState.showLoader = false;
        if (
          this.state.updatedEvent.appointmentType === EVENT_TYPES.outOfOffice
        ) {
          uiNotification.error("Provider is already booked at this time!");
        } else {
          this.props.history.push(
            getRescheduleRedirectUrl({
              updatedEvent: this.state.updatedEvent,
              clinicId: this.state.clinic_id,
            }),
          );
        }

        return this.setState(returnState);
      } else {
        if (
          this.state.updatedEvent.appointmentType === EVENT_TYPES.outOfOffice
        ) {
          this.props.history.push(
            getRescheduleRedirectUrl({
              updatedEvent: this.state.updatedEvent,
              clinicId: this.state.clinic_id,
              time: getOutOfOfficeRescheduleTime(this.state.updatedEvent.start),
            }),
          );
        } else {
          if (rescheduleData.fee_details?.cancellation_fee > 0) {
            returnState.cancellation_fee =
              rescheduleData.fee_details.cancellation_fee;
            returnState.showLoader = false;
            returnState.showAppointmentDetails = false;
            returnState.showModal = true;

            return this.setState(returnState);
          } else {
            returnState.showLoader = true;
            this.handleReschedule(
              buildRescheduleAppointmentData(this.state.updatedEvent),
            );

            return this.setState(returnState);
          }
        }
      }
    });
  };

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClick, false);
    document.body.style.overflow = "";
    uiNotification.clear();
  }

  handleClick = (e) => {
    if (
      (this.state.showProvider ||
        this.state.showClinics ||
        this.state.showService) &&
      e.target.parentElement?.className !== "cal-filter-outer"
    ) {
      if (this.state.showService && !this.refServiceButton.contains(e.target)) {
        this.setState({ showService: false });
      }
      if (
        this.state.showProvider &&
        !this.refProviderButton.contains(e.target)
      ) {
        this.setState({ showProvider: false });
      }
      if (this.state.showClinics && !this.refClinicButton.contains(e.target)) {
        this.setState({ showClinics: false });
      }
    }
  };

  componentDidMount() {
    document.addEventListener("click", this.handleClick, false);
    let formData = {};
    formData.start = this.props.match.params.date
      ? moment(this.props.match.params.date).format("YYYY-MM-DD")
      : moment().format("YYYY-MM-DD");
    formData.end = this.props.match.params.date
      ? moment(this.props.match.params.date).format("YYYY-MM-DD")
      : moment().format("YYYY-MM-DD");
    let returnState = {};
    returnState.calendarView = Views.DAY;
    returnState.showLoader = true;
    returnState.showModal = false;
    returnState.searchPickerDate = this.props.match.params.date
      ? moment(this.props.match.params.date).toDate()
      : moment().toDate();
    returnState.selectedDate = this.props.match.params.date
      ? moment(this.props.match.params.date).toDate()
      : moment().toDate();

    if (+this.props.match.params.clinicId) {
      returnState.clinic_id = this.props.match.params.clinicId;
      formData.clinic_id = this.props.match.params.clinicId;
    } else {
      returnState.clinic_id = "";
      formData.clinic_id = "";
    }

    if (this.props.match.params.appointmentId) {
      returnState.dontShowAppointment = true;
      returnState.editAppointmentId = this.props.match.params.appointmentId;
      returnState.showAppointmentDetails = true;
      this.setState(returnState);
    } else if (localStorage.getItem("providerWeekFilter")) {
      let calendarFilter = JSON.parse(
        localStorage.getItem("providerWeekFilter"),
      );
      let date = this.props.match.params.date
        ? moment(this.props.match.params.date).toDate()
        : moment(calendarFilter.searchPickerDate).toDate();
      returnState.searchPickerDate = moment(date).toDate();
      returnState.showSelectedDate = viewDateFormat(date);
      formData.start = formData.end = apiDateFormat(date);
      formData.doctor_ids = calendarFilter.doctor_ids;
      formData.service_ids = calendarFilter.service_ids;
      formData.clinic_id = +this.props.match.params.clinicId
        ? this.props.match.params.clinicId
        : calendarFilter.clinic_id;
      returnState.clinic_id = +this.props.match.params.clinicId
        ? this.props.match.params.clinicId
        : calendarFilter.clinic_id;
      returnState.selectedProviders = calendarFilter.doctor_ids;
      returnState.selectedServices = calendarFilter.service_ids;
      if (returnState.selectedServices) {
        returnState.selectedServices.map((obj) => {
          returnState["service-" + obj] = true;
        });
      }
      this.setState(returnState);
      this.getProviderAppointments(formData, calendarFilter.calendarView);
    } else {
      this.setState(returnState);
      this.getProviderAppointments(formData);
    }
    let windowHeight = parseInt(window.innerHeight);
    let calendarHeight = windowHeight - 267;
    document.getElementById("juvly-section").style.height =
      calendarHeight + "px";
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let returnState = {};

    if (nextProps.showLoader != undefined && nextProps.showLoader == false) {
      returnState.showLoader = false;
      return returnState;
    }
    if (
      nextProps.notificationSent != undefined &&
      nextProps.notificationSent == true &&
      nextProps.notiTimeStamp != prevState.notiTimeStamp
    ) {
      if (localStorage.getItem("showLoader") == "false") {
        returnState.showLoader = false;
        returnState.showNotifyPop = false;
        returnState.notificationSent = nextProps.notificationSent;
        returnState.notiTimeStamp = nextProps.notiTimeStamp;
        return returnState;
      }
    }

    if (
      nextProps.appointmentsData != undefined &&
      nextProps.appointmentsData !== prevState.appointmentsData &&
      nextProps.appointmentsTimestamp != prevState.appointmentsTimestamp
    ) {
      if (localStorage.getItem("showLoader") == "false") {
        let resourceMap = [],
          appointments = [];

        if (nextProps.appointmentsData.providers.length) {
          nextProps.appointmentsData.providers.map((obj) => {
            if (
              nextProps.appointmentsData.doctor_ids &&
              nextProps.appointmentsData.doctor_ids.indexOf(obj.id) > -1
            ) {
              returnState["provider-" + obj.id] = true;
            }
          });
          returnState.provider_id = nextProps.appointmentsData.provider_id;
        }
        if (localStorage.getItem("providerWeekFilter")) {
          let calendarFilter = JSON.parse(
            localStorage.getItem("providerWeekFilter"),
          );
          if (
            Number(calendarFilter.clinic_id) !==
            Number(nextProps.appointmentsData.clinic_id)
          ) {
            returnState.selectedProviders = [];
          } else {
            returnState.selectedProviders =
              nextProps.appointmentsData.doctor_ids;
          }
        } else {
          returnState.selectedProviders = nextProps.appointmentsData.doctor_ids;
        }
        if (prevState.dontShowAppointment) {
          returnState.dontShowAppointment = false;
        }
        if (
          nextProps.appointmentsData.verticals &&
          nextProps.appointmentsData.verticals.length &&
          prevState.calendarView === Views.DAY
        ) {
          returnState.verticalsList = [{ id: 0, name: "Default View" }].concat(
            nextProps.appointmentsData.verticals,
          );
        }
        if (nextProps.appointmentsData.appointments.length) {
          nextProps.appointmentsData.appointments.map((obj) => {
            appointments.push(
              mapAppointmentToCalendarEvent(obj, {
                getColor: (appointment) => appointment.color,
              }),
            );
          });
        }
        let resourcesSource;
        if (prevState.verticalsEnabled) {
          resourcesSource = nextProps.appointmentsData.providers;
        } else {
          resourcesSource = nextProps.appointmentsData.resources;
        }
        if (resourcesSource.length) {
          resourcesSource.map((obj) => {
            if (
              (prevState.selectedProviders &&
                prevState.selectedProviders.find((p) => p === obj.id)) ||
              (nextProps.appointmentsData.providers &&
                nextProps.appointmentsData.doctor_ids &&
                nextProps.appointmentsData.providers.length ===
                  nextProps.appointmentsData.doctor_ids.length)
            ) {
              resourceMap.push({
                resourceId: obj.id,
                resourceTitle: displayName(obj),
                resourceColor: "#FF1493",
                resourceUrl: `/appointment/provider/${obj.id}/clinic/${
                  nextProps.appointmentsData.clinic_id
                }/${prevState.calendarView}/${moment(
                  prevState.searchPickerDate,
                ).format("YYYY-MM-DD")}`,
                workingHours: obj.working_hours,
              });
            }
            if (obj.working_hours) {
              obj.working_hours.map((time) => {
                if (time.schedule) {
                  time.schedule.map((sc) => {
                    appointments.unshift(
                      mapAvailabilityScheduleToEvent({
                        provider: obj,
                        schedule: sc,
                        timeFormat: prevState.timeFormat,
                      }),
                    );
                  });
                }
              });
            }
          });
        } else {
          resourceMap.push({
            resourceId: 0,
            resourceTitle: "",
            resourceColor: "#FF1493",
          });
        }

        let clinic = nextProps.appointmentsData.clinics.find(
          (y) => Number(y.id) === Number(nextProps.appointmentsData.clinic_id),
        );
        let open = nextProps.appointmentsData.clinicOpensAt.split(":");
        let close = nextProps.appointmentsData.clinicClosesAt.split(":");
        returnState.events = prevState.forceChanged
          ? prevState.events
          : appointments;
        returnState.clinics = nextProps.appointmentsData.clinics;
        returnState.providers = nextProps.appointmentsData.providers;
        returnState.tmpProviders = nextProps.appointmentsData.providers;
        returnState.appointmentsTimestamp = nextProps.appointmentsTimestamp;
        returnState.clinic_timezone =
          nextProps.appointmentsData.clinic_timezone;
        if (nextProps.appointmentsData.providers.length === 0) {
          for (let x in prevState) {
            if (x.startsWith("provider-")) {
              returnState[x] = false;
            }
          }
        }

        returnState.resourceMap = resourceMap;
        returnState.clinic_id = nextProps.appointmentsData.clinic_id;
        returnState.selectedClinic = clinic ? clinic.clinic_name : "";
        returnState.showLoader = false;
        returnState.forceChanged = false;
        returnState.selectAllProviders = !!(
          prevState.selectedProviders &&
          prevState.selectedProviders.length ===
            returnState.selectedProviders.length
        );
        returnState.min = new Date(2019, 1, 28, open[0], open[1], open[2]);
        returnState.max = new Date(2019, 1, 28, close[0], close[1], close[2]);
      }
      return returnState;
    }

    return null;
  }

  getProviderAppointments = (formData) => {
    const verticalsIdsArr = [];
    if (this.state.selectedVertical.id !== 0) {
      verticalsIdsArr.push(this.state.selectedVertical.id);
      formData.vertical_ids = verticalsIdsArr;
    }
    if (!this.state.needAppointmentsUpdate) {
      this.setState({
        showLoader: false,
        needAppointmentsUpdate: true,
      });
    } else {
      this.props.getProviderAppointments(formData, this.state.verticalsEnabled);
    }
  };

  handleInputChange = (event) => {
    const target = event.target;
    let value = target.value;
    let name = event.target.name;
    let returnState = {};
    returnState.needAppointmentsUpdate = true;
    switch (target.type) {
      case "checkbox": {
        value = target.checked;
        break;
      }

      case "radio": {
        value = target.value;
        break;
      }
    }

    if (name === "provider_id") {
      returnState.clinic_id = "";
    }

    if (name.startsWith("provider-")) {
      let nameArr = name.split("-");
      let providerId = parseInt(nameArr[1]);
      let selectedProviders = this.state.selectedProviders;
      if (value) {
        selectedProviders.push(providerId);
      } else {
        let index = selectedProviders.indexOf(providerId);
        if (index > -1) {
          selectedProviders.splice(index, 1);
        }
      }
      returnState.selectedProviders = selectedProviders;
    }

    if (name.startsWith("sep-provider-")) {
      let nameArr = name.split("-");
      let providerId = parseInt(nameArr[2]);
      let selectedProviders = this.state.selectedProviders;
      if (providerId === 0) {
        const isAllSelected = this.state.tmpProviders.every(
          (p) => this.state["provider-" + p.id],
        );
        const selectedProviders = [];
        returnState.selectAllProviders = !isAllSelected;
        this.state.providers.map((obj) => {
          returnState["provider-" + obj.id] = !isAllSelected;
          selectedProviders.push(obj.id);
        });
        returnState.selectedProviders = !isAllSelected ? selectedProviders : [];
        returnState.needAppointmentsUpdate = !isAllSelected;
      } else {
        if (value) {
          selectedProviders.push(providerId);
        } else {
          let index = selectedProviders.indexOf(providerId);
          if (index > -1) {
            selectedProviders.splice(index, 1);
          }
        }
        returnState["provider-" + providerId] = value;
        returnState.selectedProviders = selectedProviders;
        returnState.needAppointmentsUpdate = !!selectedProviders.length;
      }
    }

    if (name.startsWith("service-")) {
      let nameArr = name.split("-");
      let serviceId = nameArr[1];
      let selectedServices = this.state.selectedServices;
      if (value) {
        selectedServices.push(serviceId);
      } else {
        let index = selectedServices.indexOf(serviceId);
        if (index > -1) {
          selectedServices.splice(index, 1);
        }
      }
      returnState.selectedServices = selectedServices;
    }

    if (name === "notification_type" && value) {
      returnState.notification_body =
        value === "sms"
          ? this.state.appointment_sms
          : this.state.appointment_email_text;
    }

    if (name === "searchProvider") {
      let result = this.state.providers.filter((word) => {
        let name = displayName(word).toLowerCase();
        return name.indexOf(value.trim().toLowerCase()) > -1;
      });
      this.setState({ tmpProviders: result });
    }

    returnState[event.target.name] = value;

    if (
      !name.startsWith("notes-") &&
      name !== "notification_body" &&
      name !== "notification_type" &&
      name !== "notes" &&
      !name.startsWith("provider-") &&
      !name.startsWith("service-") &&
      !name.startsWith("searchProvider")
    ) {
      localStorage.setItem("showLoader", true);
      returnState.showLoader = true;
      let startEndDateWeek = getCalendarDateRange({
        view: this.state.calendarView,
        selectedDate: this.state.selectedDate,
      });

      this.setState(returnState, () => {
        this.refreshAppointments(
          startEndDateWeek.start,
          startEndDateWeek.end,
          this.state.calendarView,
        );
      });
    } else {
      this.setState(returnState);
    }
  };

  handleNextPrevDate = (navigate) => {
    let calendarView = this.state.calendarView;
    let returnState = getCalendarNavigationState({
      view: calendarView,
      selectedDate: this.state.selectedDate,
      navigate,
    });
    localStorage.setItem("showLoader", true);
    returnState.showLoader = true;

    let startEndDateWeek = getCalendarFetchRange({
      view: calendarView,
      selectedDate: returnState.selectedDate,
    });
    this.setState(returnState, () => {
      this.refreshAppointments(
        startEndDateWeek.start,
        startEndDateWeek.end,
        this.state.calendarView,
      );
    });
  };

  showEvent = (event) => {
    if (event.appointmentType === EVENT_TYPES.breakTime) {
      return false;
    }

    if (event.availabilityGrid) {
      return this.handleSelect(event);
    }

    this.setState({
      editAppointmentId: event.id,
      showAppointmentDetails: true,
    });
  };

  closePopUp = () => {
    this.setState({
      showAppointmentDetails: false,
    });
  };

  toggleProvider = (event) => {
    event.stopPropagation();
    this.setState({
      showClinics: false,
      showService: false,
      showProvider: true,
    });
  };

  refreshAppointments = async (start, end, view = "") => {
    let formData = {};
    if (isEmpty(view)) {
      view = this.state.calendarView;
    }
    let startEndDateWeek = getCalendarDateRange({
      view,
      selectedDate: this.state.selectedDate,
    });
    formData.start = start
      ? apiDateFormat(start)
      : apiDateFormat(startEndDateWeek.start);
    formData.end = end
      ? apiDateFormat(end)
      : apiDateFormat(startEndDateWeek.end);
    formData.doctor_ids = this.state.providers.length
      ? this.state.selectedProviders
      : [];
    formData.clinic_id = this.state.clinic_id;

    if (this.state.clinic_id) {
      formData.clinic_id = this.state.clinic_id;
    }

    let calendarFilter = JSON.parse(JSON.stringify(formData));

    calendarFilter.searchPickerDate = this.state.selectedDate;
    calendarFilter.calendarView = view;
    localStorage.setItem("providerWeekFilter", JSON.stringify(calendarFilter));
    this.setState({
      showClinics: false,
      showService: false,
      showProvider: false,
      showLoader: true,
    });
    return this.getProviderAppointments(formData, view);
  };

  changeClinic = (event) => {
    localStorage.setItem("showLoader", true);
    let clinicId = parseInt(event.currentTarget.dataset.id);
    let formData = {},
      returnState = {},
      clinic = {};

    let dateToSend = this.getFormDataDate();
    formData.start = apiDateFormat(dateToSend.start);
    formData.end = apiDateFormat(dateToSend.end);
    formData.doctor_ids = [];
    formData.clinic_id = clinicId;
    if (clinicId) {
      clinic = this.state.clinics.find(
        (y) => Number(y.id) === Number(clinicId),
      );
      returnState.selectedClinic = clinic.clinic_name;
    } else {
      returnState.clinic_id = clinicId;
      returnState.selectedClinic = "Please Select";
    }

    returnState.showLoader = true;
    returnState.provider_id = [];
    this.setState(returnState);
    let calendarFilter = JSON.stringify(formData);
    localStorage.setItem("providerWeekFilter", calendarFilter);
    this.getProviderAppointments(formData);
  };

  changeVertical = (verticalId) => {
    localStorage.setItem("showLoader", true);
    const selectedVertical = this.state.verticalsList.find(
      (v) => v.id === verticalId,
    );
    const verticalsIdsArr = [];
    let formData = {},
      returnState = {},
      dateToSend = this.getFormDataDate();
    formData.start = apiDateFormat(dateToSend.start);
    formData.end = apiDateFormat(dateToSend.end);
    formData.doctor_ids = this.state.selectedProviders;
    formData.clinic_id = this.state.clinic_id;
    if (verticalId === 0) {
      this.state.verticalsList.map(
        (v) => v.id !== 0 && verticalsIdsArr.push(v.id),
      );
    } else {
      verticalsIdsArr.push(selectedVertical.id);
    }
    formData.vertical_ids = verticalsIdsArr;
    returnState.selectedVertical = selectedVertical;
    returnState.showLoader = true;
    this.setState(returnState, () => {
      let calendarFilter = JSON.stringify(formData);
      localStorage.setItem("providerWeekFilter", calendarFilter);
      this.getProviderAppointments(formData, this.state.calendarView);
    });
  };

  handleCalendarView = (nextCalendarView) => {
    localStorage.setItem("showLoader", true);
    let returnState = getCalendarViewDateState({
      view: nextCalendarView,
      date: this.state.selectedDate,
    });
    returnState.calendarView = nextCalendarView;
    returnState.showLoader = true;
    let startEndDateWeek = getCalendarFetchRange({
      view: nextCalendarView,
      selectedDate: returnState.selectedDate,
    });
    this.setState(returnState);
    this.setState(returnState, () => {
      this.refreshAppointments(
        startEndDateWeek.start,
        startEndDateWeek.end,
        nextCalendarView,
      );
    });
  };

  getFormDataDate = () => {
    return getCalendarFetchRange({
      view: this.state.calendarView,
      selectedDate: this.state.selectedDate,
    });
  };

  handleSearchDatePicker = (date) => {
    localStorage.setItem("showLoader", true);
    let returnState = getCalendarViewDateState({
      view: this.state.calendarView,
      date,
    });
    returnState.showLoader = true;
    returnState.calendarView = this.state.calendarView;
    let startEndDateWeek = getCalendarFetchRange({
      view: this.state.calendarView,
      selectedDate: date,
    });
    this.setState(returnState, () => {
      this.refreshAppointments(startEndDateWeek.start, startEndDateWeek.end);
    });
  };

  componentDidUpdate = (prevProps) => {
    if (
      this.state.showModal ||
      this.state.showPrintModal ||
      this.state.showRescheduleConfirmModal ||
      this.state.showAppointmentDetails ||
      this.state.showNotifyPop
    ) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    ReactTooltip.rebuild();

    if (
      (!prevProps.appointmentDataStatus ||
        prevProps.appointmentDataStatus === "pending") &&
      this.props.appointmentDataStatus === "loading"
    ) {
      this.setState({ showLoader: true });
    }

    if (
      prevProps.appointmentDataStatus === "success" &&
      this.props.appointmentDataStatus === "loading"
    ) {
      this.setState({ showLoader: true });
    }

    if (
      prevProps.appointmentDataStatus === "loading" &&
      this.props.appointmentDataStatus === "success"
    ) {
      this.setState({
        showLoader: false,
      });
    }
  };

  sendNotification = () => {
    if (!this.state.notification_body.trim()) {
      return false;
    }
    localStorage.setItem("showLoader", true);
    this.setState({ showLoader: true });
    let formData = buildRescheduleNotificationData({
      appointmentId: this.state.appointment_id,
      notificationType: this.state.notification_type,
      notificationBody: this.state.notification_body,
      appointmentSubject: this.state.appointment_subject,
      appointmentSms: this.state.appointment_sms,
    });
    this.props.sendNotification(formData).then(() => {
      this.refreshAppointments();
    });
  };

  dismissModal = () => {
    this.setState({ showModal: !this.state.showModal });
  };

  dismissRescheduleModal = () => {
    this.setState({
      showRescheduleConfirmModal: !this.state.showRescheduleConfirmModal,
    });
  };

  dismissPrintModal = () => {
    this.setState({
      showPrintModal: !this.state.showPrintModal,
    });
  };

  toggleAllProviders = (event) => {
    event.stopPropagation();
    let allServices = this.state.providers;
    let returnState = {};
    let x = !this.state.selectAllProviders;
    let selectedProviders = [];
    returnState.selectAllProviders = x;
    allServices.map((obj) => {
      returnState["provider-" + obj.id] = x;
      selectedProviders.push(obj.id);
    });
    returnState.selectedProviders = x ? selectedProviders : [];
    this.setState(returnState);
  };

  applyFilter = (event) => {
    event.stopPropagation();
    localStorage.setItem("showLoader", true);
    this.refreshAppointments();
  };

  printAppt = (data) => {
    this.setState({ showLoader: true });
    this.props
      .printAppointment(data)
      .then((res) => {
        if (res.data?.file) {
          window.open(res.data.file);
        }
      })
      .catch(() => {
        uiNotification.error("Unable to print. Try again later.");
      })
      .finally(() => {
        this.setState({ showPrintModal: false, showLoader: false });
      });
  };

  print = (mode) => {
    if (localStorage.getItem("providerWeekFilter")) {
      localStorage.setItem("showLoader", true);
      this.setState({ showLoader: true });
      let calendarFilter = JSON.parse(
        localStorage.getItem("providerWeekFilter"),
      );
      if (!calendarFilter.clinic_id) {
        calendarFilter.clinic_id = this.state.clinic_id;
      }
      calendarFilter.print_type = mode;
      calendarFilter.doctor_ids = this.state.selectedProviders;
      this.printAppt(calendarFilter);
    } else {
      let formData = {};
      formData.print_type = mode;
      formData.start = moment().format("YYYY-MM-DD");
      formData.end = moment().format("YYYY-MM-DD");
      formData.clinic_id = this.state.clinic_id;
      formData.doctor_ids = this.state.selectedProviders;
      this.printAppt(formData);
    }
  };

  closeNotiPop = () => {
    uiNotification.success(this.state.globalLang[this.state.success_msg]);

    this.setState({
      showNotifyPop: !this.state.showNotifyPop,
    });

    this.refreshAppointments();
  };

  chargeAndReschedule = (event) => {
    let charge = event.currentTarget.dataset.charge;
    let formData = buildChargeAndRescheduleData({
      updatedEvent: this.state.updatedEvent,
      charge,
    });
    localStorage.setItem("showLoader", true);
    this.setState({ showModal: false, showLoader: true });
    this.handleReschedule(formData);
  };

  setTodayDate = () => {
    let returnState = getCalendarViewDateState({
      view: this.state.calendarView,
      date: moment(new Date()).toDate(),
    });

    this.setState(returnState, () => {
      this.handleCalendarView(this.state.calendarView);
    });
  };

  handleEditorChange = (childState) => {
    this.setState(childState);
  };

  render() {
    const stringLengt = this.state.selectedClinic;
    let curDomain = this.props?.currentBookingUrls?.domainName;

    const baseDomainUrl =
      this.state.userData.host_name +
      this.state.userData.account.pportal_subdomain +
      "." +
      curDomain +
      "/book/appointments?user_id=" +
      this.state.userData.user.hash_id;

    const newDomainUrl =
      this.state.userData.host_name +
      curDomain +
      "/book/appointments?user_id=" +
      this.state.userData.user.hash_id;

    const smartBookingUrl = this.props?.currentBookingUrls?.useCustomDomain
      ? newDomainUrl
      : baseDomainUrl;

    const pName = this.state.patient_name || "";

    const selectAllProvidersLabel = this.state.selectAllProviders
      ? "Unselect All"
      : "Select All";

    return (
      <div id="content">
        <div className="container-fluid content">
          <div className="juvly-section full-width m-b-0">
            <div className="calender-title">
              <div className={classes.header}>
                <div className={classes.left}>
                  <span className={classes.name}>Calendar</span>
                  {this.state.calendarView === Views.DAY ? (
                    <a
                      onClick={this.setTodayDate}
                      className="new-line-btn no-width m-0"
                    >
                      Today
                    </a>
                  ) : (
                    <div className="cal-date-btn-outer calViewCal">
                      <div
                        className="search-bg new-calender"
                        ref={(refSearchDatePickerContainer) =>
                          (this.refSearchDatePickerContainer =
                            refSearchDatePickerContainer)
                        }
                      >
                        <img alt="" src={calenLogo} />
                        <DatePicker
                          value={
                            this.state.searchPickerDate
                              ? viewDateFormat(this.state.searchPickerDate)
                              : null
                          }
                          onChange={this.handleSearchDatePicker}
                          className="setting-search-input search-key"
                          dateFormat="YYYY-MM-dd"
                          minDate={new Date(moment().subtract(10, "years"))}
                          selected={this.state.searchPickerDate}
                          name="searchPickerDate"
                          autoComplete="off"
                          ref={(refSearchDatePicker) =>
                            (this.refSearchDatePicker = refSearchDatePicker)
                          }
                        />
                      </div>
                    </div>
                  )}
                  <div className="cal-arrow-outer m-0">
                    <a
                      className="cal-arrow pull-left"
                      onClick={this.handleNextPrevDate.bind(this, "prev")}
                    >
                      <img alt="" src="/images/cal-arrow-left.png" />
                    </a>
                    <a
                      className="cal-arrow pull-right"
                      onClick={this.handleNextPrevDate.bind(this, "next")}
                    >
                      <img alt="" src="/images/cal-arrow-right.png" />
                    </a>
                  </div>
                  {this.state.calendarView === Views.DAY && (
                    <div className="calName p-0">
                      {moment(this.state.searchPickerDate).format(
                        "MMMM Do, YYYY",
                      )}
                    </div>
                  )}
                  {this.state.calendarView === Views.DAY &&
                    this.state.verticalsEnabled && (
                      <div className="calName p-0">
                        {!!this.state.selectedVertical &&
                          this.state.selectedVertical.name}
                      </div>
                    )}
                  {this.state.calendarView === Views.WEEK && (
                    <div className="calName p-0">
                      {this.state.showSelectedDate}
                    </div>
                  )}
                  <CalendarStepSelect
                    value={this.state.calendarStep}
                    onChange={(o) => this.setState({ calendarStep: o })}
                  />
                </div>
                <div className={classes.right}>
                  {this.state.calendarView === Views.WEEK && (
                    <button
                      className="calendar-dropdown show cal-provider-filter"
                      onClick={this.toggleProvider}
                      ref={(refProviderButton) =>
                        (this.refProviderButton = refProviderButton)
                      }
                    >
                      {this.state.providers.length === 0
                        ? "No Provider"
                        : this.state.selectedProviders.length === 0
                        ? "All Providers"
                        : this.state.selectedProviders.length > 1
                        ? "(" +
                          this.state.selectedProviders.length +
                          ") Providers"
                        : "(1) Provider"}
                      <a className="cal-arrow pull-right">
                        <i className="fas fa-angle-down"></i>
                      </a>
                      <div
                        className={
                          this.state.showProvider
                            ? "filter-wid-apply-btn"
                            : "filter-wid-apply-btn no-display"
                        }
                      >
                        <div className="cal-filter-outer">
                          <a
                            className={
                              this.state.providers.length === 0
                                ? "line-btn pull-right no-display"
                                : "line-btn pull-right"
                            }
                            onClick={this.applyFilter}
                            disabled={this.state.providers.length}
                          >
                            {this.state.appointmentLang.appointment_apply}
                          </a>
                          <a
                            className={
                              this.state.providers.length === 0
                                ? "line-btn pull-right no-display"
                                : "line-btn pull-right"
                            }
                            onClick={this.toggleAllProviders}
                            disabled={this.state.providers.length}
                          >
                            {selectAllProvidersLabel}
                          </a>
                        </div>
                        <ul
                          className={
                            this.state.providers.length > 0
                              ? "cal-dropdown cal-service-dropdown"
                              : "cal-dropdown cal-service-dropdown no-visible"
                          }
                        >
                          {this.state.providers.length > 0 &&
                            this.state.providers.map((obj, idx) => {
                              return (
                                <li key={"provider-" + idx}>
                                  <a>
                                    <label className="checkbox">
                                      <input
                                        type="checkbox"
                                        value={this.state["provider-" + obj.id]}
                                        name={"provider-" + obj.id}
                                        onChange={this.handleInputChange}
                                        checked={
                                          this.state["provider-" + obj.id]
                                            ? "checked"
                                            : false
                                        }
                                      />{" "}
                                      {displayName(obj)}
                                      <span
                                        className="filter-provider-span"
                                        style={{
                                          backgroundColor:
                                            obj.appointment_color,
                                        }}
                                      >
                                        {" "}
                                      </span>
                                    </label>
                                  </a>
                                </li>
                              );
                            })}
                        </ul>
                        <div
                          className={
                            this.state.providers.length === 0
                              ? "no-record"
                              : "no-display"
                          }
                        >
                          {
                            this.state.appointmentLang
                              .appointment_no_provider_found
                          }
                        </div>
                      </div>
                    </button>
                  )}
                  {!!this.state.verticalsList &&
                    !!this.state.verticalsList.length &&
                    this.state.calendarView === Views.DAY && (
                      <div className="calClinicdropDown">
                        <div className="dropdown pull-left weekDropdowncal">
                          <button
                            className="btn btn-default dropdown-toggle cal-clinic-filter"
                            type="button"
                            id="dropdownMenuVerticals"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            {this.state.selectedVertical.name &&
                            this.state.selectedVertical.name.length > 16
                              ? this.state.selectedVertical.name.substring(
                                  0,
                                  16,
                                ) + "..."
                              : this.state.selectedVertical.name}
                            <i className="fas fa-angle-down" />
                          </button>
                          <ul
                            className="dropdown-menu cal-dropdown clinicname-dropdown"
                            aria-labelledby="dropdownMenuVerticals"
                          >
                            <Scrollbars
                              autoHeight
                              autoHeightMin={0}
                              autoHeightMax={306}
                              className="full-width"
                              renderTrackHorizontal={(props) => (
                                <div
                                  {...props}
                                  style={{ display: "none" }}
                                  className="track-horizontal"
                                />
                              )}
                            >
                              {this.state.verticalsList.length > 0 &&
                                this.state.verticalsList.map((obj) => {
                                  return (
                                    <li
                                      key={obj.id}
                                      onClick={() =>
                                        this.changeVertical(obj.id)
                                      }
                                    >
                                      <a>
                                        <label>{obj.name}</label>
                                      </a>
                                    </li>
                                  );
                                })}
                            </Scrollbars>
                          </ul>
                        </div>
                      </div>
                    )}
                  <CalendarClinicDropdown
                    selectedClinic={stringLengt}
                    clinics={this.state.clinics}
                    onChangeClinic={this.changeClinic}
                    buttonProps={{
                      id: "dropdownMenuSearch",
                      "aria-haspopup": "true",
                      "aria-expanded": "false",
                    }}
                  />
                  <div className="calWeekdropDown calviewDay">
                    <div className="dropdown pull-left weekDropdowncal">
                      <button
                        className="btn btn-default dropdown-toggle"
                        type="button"
                        id="dropdownMenuSearch"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        {capitalizeFirstLetter(this.state.calendarView)}
                        <i className="fas fa-angle-down" />
                      </button>
                      <ul
                        className="dropdown-menu"
                        aria-labelledby="dropdownMenuSearch"
                      >
                        <li>
                          <a
                            onClick={() => this.handleCalendarView(Views.WEEK)}
                            name="expType"
                          >
                            Week
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() => this.handleCalendarView(Views.DAY)}
                            name="expoType"
                          >
                            Day
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <Link
                    to={`/appointment/index/${moment(
                      this.state.searchPickerDate,
                    ).format("YYYY-MM-DD")}`}
                    className="new-blue-btn m-l-0 switchProvider"
                  >
                    Switch to Provider View
                  </Link>
                  <AppointmentHeader
                    smartBookingUrl={smartBookingUrl}
                    togglePrint={this.dismissPrintModal}
                  />
                </div>
              </div>
            </div>
            <div
              className={
                this.state.calendarView === Views.DAY
                  ? "CalendarOuter ProviderCalendar ProviderCalendarDay"
                  : "CalendarOuter p-l-0 ProviderCalendar"
              }
            >
              {this.state.calendarView === Views.DAY && (
                <div className="calendarLeftSection" id="calendarLeftSection">
                  {checkIfPermissionAllowed("create-appointment") && (
                    <Link
                      id="create_appointment1"
                      className="new-blue-btn CreateAppointmentBtn"
                      data-url="/appointments/add_appointment"
                      to={
                        "/appointment/create/" +
                        pipe(
                          this.state.selectedProviders,
                          cond(() => "0", [(x) => x.length === 1, (x) => x[0]]),
                        )
                      }
                    >
                      {"Create"}
                    </Link>
                  )}
                  <div className="leftCalendar">
                    <DatePicker
                      value={
                        this.state.searchPickerDate
                          ? viewDateFormat(this.state.searchPickerDate)
                          : null
                      }
                      onChange={this.handleSearchDatePicker}
                      className="setting-search-input search-key"
                      dateFormat="YYYY-MM-dd"
                      minDate={new Date(moment().subtract(10, "years"))}
                      selected={this.state.searchPickerDate}
                      openToDate={this.state.searchPickerDate}
                      name="searchPickerDate"
                      autoComplete="off"
                      inline
                    />
                    {!!this.state.verticalsList &&
                      !!this.state.verticalsList.length &&
                      this.state.calendarView === Views.DAY && (
                        <VerticalsLegend
                          verticals={this.state.verticalsList}
                          hideDefault
                        />
                      )}
                    <div className="sidebarSectionContainer">
                      <h3 className="sidebarHeading">Filter providers</h3>
                      <ul className="cal-dropdown">
                        <li>
                          <a>
                            <label className="checkbox">
                              <input
                                type="checkbox"
                                value="all"
                                name="sep-provider-0"
                                onChange={this.handleInputChange}
                                checked={
                                  this.state.providers.every(
                                    (p) => this.state["provider-" + p.id],
                                  )
                                    ? "checked"
                                    : false
                                }
                              />{" "}
                              All providers
                            </label>
                          </a>
                        </li>
                      </ul>
                      <input
                        type="text"
                        className="searchProvider"
                        name="searchProvider"
                        placeholder="Search Provider"
                        onChange={this.handleInputChange}
                        value={this.state.searchProvider}
                      />
                      <Scrollbars
                        autoHeight
                        autoHeightMin={0}
                        autoHeightMax={192}
                        className="full-width"
                        renderTrackHorizontal={(props) => (
                          <div
                            {...props}
                            style={{ display: "none" }}
                            className="track-horizontal"
                          />
                        )}
                      >
                        <ul
                          className={
                            this.state.tmpProviders.length > 0
                              ? "cal-dropdown"
                              : "cal-dropdown no-visible"
                          }
                        >
                          {this.state.tmpProviders.length > 0 &&
                            this.state.tmpProviders.map((obj) => {
                              return (
                                <li key={"provider-" + obj.id}>
                                  <a>
                                    <label className="checkbox">
                                      <input
                                        type="checkbox"
                                        value={obj.id}
                                        name={"sep-provider-" + obj.id}
                                        onChange={this.handleInputChange}
                                        checked={
                                          this.state["provider-" + obj.id]
                                            ? "checked"
                                            : false
                                        }
                                      />{" "}
                                      {displayName(obj)}
                                    </label>
                                  </a>
                                </li>
                              );
                            })}
                        </ul>
                      </Scrollbars>
                    </div>
                  </div>
                </div>
              )}
              <div
                className={
                  this.state.calendarView === Views.WEEK
                    ? "calendarrightSection"
                    : "calendarrightSection calendarrightSectionWithSidebar"
                }
              >
                <div
                  className={
                    this.state.calendarView === Views.WEEK
                      ? "juvly-section full-width m-t-0 week-view-calendar calendarScrollContainer"
                      : "juvly-section full-width m-t-0 day-view-calendar calendarScrollContainer"
                  }
                  id="juvly-section"
                >
                  {this.state.events && (
                    <CalendarDragAndDrop
                      events={this.state.events}
                      min={this.state.min}
                      max={this.state.max}
                      resources={this.state.resourceMap}
                      onEventDrop={this.moveEvent}
                      view={this.state.calendarView}
                      onSelectSlot={this.handleSelect}
                      onSelectEvent={this.showEvent}
                      step={this.state.calendarStep.value}
                      timeslots={this.state.calendarStep.slots}
                      date={this.state.selectedDate}
                      getNow={() => this.getNow()}
                      timeFormat={this.state.timeFormat}
                      timeRangeFormat={this.timeRangeFormat}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <CalendarModals
          state={this.state}
          appointmentLang={this.state.appointmentLang}
          patientName={pName}
          isLoading={this.state.showLoader}
          onCloseAppointmentDetails={this.closePopUp}
          refetchAppointments={this.refreshAppointments}
          onCloseNotification={this.closeNotiPop}
          handleInputChange={this.handleInputChange}
          handleEditorChange={this.handleEditorChange}
          sendNotification={this.sendNotification}
          dismissModal={this.dismissModal}
          chargeAndReschedule={this.chargeAndReschedule}
          print={this.print}
          closePrintModal={() =>
            this.setState({
              showPrintModal: false,
            })
          }
          dismissRescheduleModal={this.dismissRescheduleModal}
          rescheduleAppoint={this.rescheduleAppoint}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  let returnState = {};

  const languageData = JSON.parse(localStorage.getItem("languageData")) || {
    global: {},
  };

  returnState.appointmentDataStatus =
    state.AppointmentReducer.appointmentDataStatus;

  localStorage.setItem("showLoader", false);

  if (state?.AppointmentReducer?.action === "PROVIDER_WEEK_APPOINTMENTS") {
    if (state?.AppointmentReducer?.data?.status === 200) {
      returnState.appointmentsData = state.AppointmentReducer.data.data;
      returnState.appointmentsTimestamp = new Date();
    } else {
      uiNotification.error(
        languageData.global[state?.AppointmentReducer?.data?.message],
      );
      returnState.showLoader = false;
    }
  }

  if (state.AppointmentReducer.action === "SEND_NOTIFICATION_CALENDAR") {
    if (state.AppointmentReducer?.data?.status === 200) {
      returnState.notificationSent = true;
      returnState.notiTimeStamp = new Date();
    } else {
      uiNotification.error(
        languageData.global[state.AppointmentReducer.data.message],
      );
      returnState.showLoader = false;
    }
  }

  return returnState;
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getProviderAppointments,
      checkRescheduleTime,
      rescheduleAppointment,
      sendNotification,
      printAppointment,
    },
    dispatch,
  );
}

export default pipe(
  ProviderWeekCalendar,
  connect(mapStateToProps, mapDispatchToProps),
  withGetBookingUrlsQuery,
  DragDropContext(HTML5Backend),
);
